
import {
	Combobox as ChakraCombobox,
} from '@chakra-ui/react';

export const ComboBoxLabel = ChakraCombobox.Label;
export const ComboBoxControl = ChakraCombobox.Control;
export const ComboBoxInput = ChakraCombobox.Input;
export const ComboBoxIndicator = ChakraCombobox.Indicator;
export const ComboBoxIndicatorGroup = ChakraCombobox.IndicatorGroup;
export const ComboBoxClearTrigger = ChakraCombobox.ClearTrigger;
export const ComboBoxTrigger = ChakraCombobox.Trigger;
export const ComboBoxPositioner = ChakraCombobox.Positioner;
export const ComboBoxContent = ChakraCombobox.Content;
export const ComboBoxItem = ChakraCombobox.Item;
export const ComboBoxItemText = ChakraCombobox.ItemText;
export const ComboBoxRoot = ChakraCombobox.RootProvider;
